<template>
  <el-menu
    :default-active="activeIndex"
    class="el-menu-vertical-demo"
    text-color="#535353"
    active-text-color="#fff"
    @select="handleSelect"
  >
    <el-menu-item index="1">
      <span slot="title">我的作品</span>
    </el-menu-item>
    <el-menu-item index="5">
      <span slot="title">青青写</span>
    </el-menu-item>
    <el-menu-item index="2">
      <span slot="title">消息通知</span>
    </el-menu-item>
    <el-menu-item index="3">
      <span slot="title">绑定微信</span>
    </el-menu-item>
    <el-menu-item index="4">
      <span slot="title">我的收藏</span>
    </el-menu-item>
    <el-menu-item v-if="false" index="6">
      <span slot="title"> 获奖作品 </span>
    </el-menu-item>
  </el-menu>
</template>
<script>
export default {
  name: "LeftList",
  props: ["activeIndex"],
  data() {
    return {};
  },

  methods: {
    handleSelect(key, keyPath) {
      console.log(this.activeIndex);
      if (key == 1 && this.$route.path != "/my") {
        this.$router.replace("/my");
      } else if (key == 2 && this.$route.path != "/message") {
        this.$router.replace("/message");
      } else if (key == 3 && this.$route.path != "/bindwechat") {
        this.$router.replace("/bindwechat");
      } else if (key == 4 && this.$route.path != "/mycollect") {
        this.$router.replace("/mycollect");
      } else if (key == 5 && this.$route.path != "/myqqwriteworks") {
        this.$router.replace("/myqqwriteworks");
      } else if (key == 6 && this.$route.paht != "/award-works") {
        this.$router.replace("/award-works");
      }
    },
  },
};
</script>

<style scoped>
.el-menu {
  border-radius: 10px !important;
  background: white;
}

a,
span {
  display: table;
  width: 100%;
  height: 100%;
}

.el-menu-item.is-active {
  background-color: #3370ff !important;
  color: #fff;
}

.el-menu-item.is-active:nth-of-type(1) {
  border-radius: 10px 10px 0px 0px !important;
}

.el-menu-item.is-active:last-of-type {
  border-radius: 0px 0px 10px 10px !important;
}

.el-menu-item {
  text-align: center;
  border-bottom: 1px solid #eeeeee;
}

.el-menu-item:last-of-type {
  border: none;
}

.el-menu-item.is-active span {
  color: #fff !important;
  text-align: center;
  margin: 0 auto !important;
}

@media (min-width: 1024px) {
  .el-menu-item {
    height: 60px !important;
  }
} /*>=1024的设备*/

@media (min-width: 1100px) {
} /*>=1100的设备*/
@media (min-width: 1280px) {
  .el-menu-item {
    height: 50px !important;
  }
} /*>=1280的设备*/
</style>



// WEBPACK FOOTER //
// src/my/components/LeftList.vue